import type { ComponentProps } from 'react';
import React from 'react';
import { SmoothieScrollView, type StackProps } from 'smoothie';

const moneyMapperPanelScrollInnerStyle: StackProps = {
    width: '100%',
    marginHorizontal: 0,
    flexGrow: 1,
    paddingBottom: 16,
};

/**
 * Vertical scroll area with Money Mapper–consistent inner margins (clears
 * default SmoothieScrollView horizontal inset so content aligns with panel edges).
 */
export const MoneyMapperPanelScrollView = ({
    children,
    containerStyle,
    ...props
}: ComponentProps<typeof SmoothieScrollView>) => (
    <SmoothieScrollView
        containerStyle={{
            ...moneyMapperPanelScrollInnerStyle,
            ...containerStyle,
        }}
        {...props}
    >
        {children}
    </SmoothieScrollView>
);
